import React from "react";
import PropTypes from "prop-types";
import Client from "../../Client";
import RunsheetController from "./RunsheetController";

class RunsheetEdit extends React.Component {
  state = {
    runsheet: {}
  };

  componentDidMount() {
    const runsheetId = this.props.match.params.id;
    Client.getRunsheet(runsheetId).then(runsheet =>
      this.setState({ runsheet })
    );
  }

  handleChange = runsheet => {
    this.setState({ runsheet });
    Client.updateRunsheet(runsheet.id, runsheet).then(response =>
      this.props.history.push(`/runsheets/${response.id}`)
    );
  };

  render() {
    if (this.state.runsheet.id) {
      return (
        <RunsheetController
          initialRunsheet={this.state.runsheet}
          mode="EDIT"
          history={this.props.history}
          onChange={this.handleChange}
        />
      );
    }

    return <p>Loading...</p>;
  }
}
RunsheetEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

export default RunsheetEdit;



// WEBPACK FOOTER //
// ./src/components/runsheets/RunsheetEdit.js